import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    info: null
  },
  getters: {
    getInfo: state => {
      return state.info
    }
  },
  mutations: {
    setInfo (state, info) {
      state.info = info      
    },
    deleteInfo (state) {
      state.info = null
    }
  }
})
export default store;